var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeActive = function SvgEyeActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    style: {
      marginTop: 4
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#B2C9DE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33,
    d: "M1.333 8s2-4.667 6.667-4.667C12.666 3.333 14.666 8 14.666 8s-2 4.667-6.666 4.667C3.333 12.667 1.333 8 1.333 8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#B2C9DE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33,
    d: "M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
  })));
};
export default SvgEyeActive;